import AdminHeader from 'Components/Admin/AdminHeader';
import OptInList from 'Components/OptInList/OptInList';
import T from 'Components/Helpers/translate';

const OptIns = () => (
	<div id="admin" className="WrappedOptIns">
		<div id="admin-root">
			<div id="admin-page-optins">
				<AdminHeader
					title={T('admin.optInSettings')}
					description={T('admin.optInInfo')}
					image="optin-settings.svg"
					articleId={522}
				/>
				<div id="admin-content">
					<OptInList />
					<OptInList manual />
				</div>
			</div>
		</div>
	</div>
);

export default OptIns;
